import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import Slider from 'react-slick';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Home extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		this.state = {
			discoverVideo: false,
		}
	}

	componentWillMount() {
		document.title = 'Diamonds Direct - Engagement Rings, Jewelry, and More';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

	componentDidMount() {
    // setTimeout(() => {
    // 	this.props.commonNotify();
    // }, 1000);
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  giftsNav(page) {
	window.location.href = 'https://gifts.diamondsdirect.com';
  }

  getDiscoverVideoClass() {
  	return this.state.discoverVideo ? 'videoElement watchVideo' : 'videoElement imgCover';
  }

  ggEarringNav() {
  	window.location.href = 'https://gifts.diamondsdirect.com/';
  }

  startVideo() {
  	this.setState({
  		discoverVideo: true,
  	}, () => {
  		this.discover.play();
  	});
  }

  openIntercom() {
    acquireIO.max();
  }
  			
  // <source src="https://s3.amazonaws.com/dd-website/img/home/videobannera.mp4" type="video/mp4" />
  			

		// Hurricane Banner
		// <div className='hurricaneBanner'>
		// 		<div className='hurricaneContentWrapper'>
		// 			<div className='hurricaneInnerWrapper'>
		// 				<div>
		// 					Dear Customers, some of our locations may experience closures and/or delays this week due to Hurricane Florence. We are actively taking measures to ensure all staff and merchandise is secure during this time. Please also be aware that our shipping partner, FedEx, has released a nationwide bulletin warning of shipping delays across the Southeast due to the storm. We thank you for your trust and patience as we work through the challenges this storm may present. Our number one goal is your satisfaction and our team of diamond experts is prepared to answer all of your questions during this time. To inquire about store hours and orders placed instore, please visit our <span className='hurricaneStrong' onClick={() => {this.internalNav('locations')}}>locations page</span> and contact the store nearest you. For online orders, please utilize our <span className='hurricaneStrong' onClick={::this.openIntercom}>chat feature</span> or call <span className='hurricaneStrong' style={{cursor: 'default'}}><a href='tel:7047144626'>704-714-4626</a></span>. From all of us at Diamonds Direct, stay safe out there!
		// 				</div>
		// 			</div>
		// 		</div>
		// 	</div>

		// <div className='homeBanner'>
		// 	  <img className='desktop600' src='https://s3.amazonaws.com/dd-website/img/home/ca2018/homepage-b.jpg' />
		// 		<img className='mobile600' src='https://s3.amazonaws.com/dd-website/img/home/ca2018/homepage_mobile-b.jpg' />
		// 		<div className={'bannerOverlay caBannerOverlay desktop600'}>
		// 			<div className={'bannerButton caBannerButton'} onClick={() => this.userNav('locations')}>Visit Us</div>
		// 		</div>
		// 		<div className={'mobileBannerOverlay mobile600'}>
		// 			<div className={'bannerButton caBannerButton'} onClick={() => this.userNav('locations')}>Visit Us</div>
		// 		</div>
		// 	</div>



		


		// <div className={'mobileBannerOverlay mobile600'}>
		// 			<div className='bannerHeadline'>Your&nbsp;love.&nbsp; Our&nbsp;passion.</div>
		// 			<div className='bannerButton' onClick={() => this.userNav('catalogsearch/advanced/?a=1&prod_type=engagement&attr=&opt=&dsgnr_id=&prc_min=1&prc_max=20000&order_by=rnd&limit=12&pg_no=1&url_prod_type=&q=')}>Engagement Rings</div>
		// 		</div>

	nextSlide() {
    this.sliderObject.slickNext();
  }

  prevSlide() {
    this.sliderObject.slickPrev();
  }

	renderRotatingBanner() {
		const settings = {
			dots: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			speed: 500,
			autoplaySpeed: 5000,
			cssEase: "linear",
			arrows: false,
			adaptiveHeight: true,
		};

  	return <div className='homeRotatingBanner'>
			<div className="bannerLeft" onClick={::this.prevSlide}>
				<div className="leftArrow"></div>
			</div>
			<div className="bannerRight" onClick={::this.nextSlide}>
				<div className="rightArrow"></div>
			</div>
			<Slider ref={(slider) => { this.sliderObject = slider; }} {...settings}>

				<div className={'homeBanner rotatingBannerItem'} onClick={() => this.internalNav('holiday')}>
		  		<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/ee_homepage.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/ee_homepage_m.jpg' />
					<div className={'promoBannerButton variant4'} onClick={() => this.internalNav('holiday')}><div>Shop Now</div></div>
				</div>

				<div className={'homeBanner rotatingBannerItem'}>
		  		<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/december2022/decfi_homepage.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/december2022/decfi_homepage_m.jpg' />
					<div className={'promoBannerButton'} onClick={() => this.internalNav('3yearfinancing')}><div>Learn More</div></div>
				</div>

				<div className={'homeBanner rotatingBannerItem'}>
		  		<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2_m.jpg' />
					<div className={'promoBannerButton variant2'} onClick={this.giftsNav.bind(this)}><div>Shop Now</div></div>
				</div>

				<div className={'homeBanner rotatingBannerItem'}>
		  		<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex_m.jpg' />
					<div className={'promoBannerButton variant3'} onClick={() => this.internalNav('locations')}><div>Find a Location</div></div>
				</div>

			</Slider>
		</div>;
	}

  renderOldDefaultBanner() {

  	return <div className='homeBanner'>
				<video className='desktop600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
				  <source src="https://s3.amazonaws.com/dd-website/img/home/dd_homepage_m2019.mp4" type="video/mp4" />
				  <LazyLoadImage className='desktop600' src='https://s3.amazonaws.com/dd-website/img/home/homepagebanner.jpg' alt='Diamonds Direct' />
				</video>
				<video className='mobile600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeMobile = vid; }}>
					<source src="https://s3.amazonaws.com/dd-website/img/home/dd_homepage_mobile_m2019.mp4" type="video/mp4" />
					<LazyLoadImage className='mobile600' src='https://s3.amazonaws.com/dd-website/img/home/mobile_homepage.jpg' alt='Diamonds Direct' />
				</video>
				<div className={'bannerOverlay desktop600'}>
					<div className='bannerHeadline'>Your&nbsp;love.&nbsp; Our&nbsp;passion.</div>
					<div className='bannerButton' onClick={() => this.internalNav('gallery/engagement-rings')}>Engagement Rings</div>
				</div>
				<div className={'mobileBannerOverlay mobile600'}>
					<div className='bannerHeadline'>Your&nbsp;love.&nbsp; Our&nbsp;passion.</div>
					<div className='bannerButton' onClick={() => this.internalNav('gallery/engagement-rings')}>Engagement Rings</div>
				</div>
			</div>;
  }

  renderDefaultBanner() {

  	return <div className={'homeBanner2 newBanner22'}>

  			<LazyLoadImage className='desktop600' src='https://s3.amazonaws.com/dd-website/img/home/homepage.jpg' />
				<LazyLoadImage className='mobile600' src='https://s3.amazonaws.com/dd-website/img/home/homepage_m.jpg' />

				<div className={'bannerOverlay desktop600'}>
					<div className='bannerButton' onClick={() => this.internalNav('gallery/engagement-rings')}><div>Engagement Rings</div></div>
				</div>
				<div className={'mobileBannerOverlay mobile600'}>
					<div className='bannerButton' onClick={() => this.internalNav('gallery/engagement-rings')}><div>Engagement Rings</div></div>
				</div>
			</div>;
  }

  renderValentines2019Banner() {

  	return <div className={'homeBanner'}>
			<video className='desktop600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/home/promo-banners/valentines2019/homepage.mp4" type="video/mp4" />
			</video>
			<video className='mobile600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/home/promo-banners/valentines2019/homepage_mobile.mp4" type="video/mp4" />
			</video>
			<div className={'valentinesBannerOverlay bannerOverlay desktop600'}>
				<div className='valentinesBannerButton' onClick={() => this.userNav('valentinesday')}>
					Learn More
				</div>
			</div>
			<div className={'valentinesBannerOverlay bannerOverlay mobile600'}>
				<div className='valentinesBannerButton' onClick={() => this.userNav('valentinesday')}>
					Learn More
				</div>
			</div>
		</div>;
  }

  renderSpring2019Banner() {

  	return <div className={'homeBanner'}>
			<video className='desktop600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/home/promo-banners/spring2019/dd_spring_b.mp4" type="video/mp4" />
			</video>
			<video className='mobile600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/home/promo-banners/spring2019/dd_spring_mobile_b.mp4" type="video/mp4" />
			</video>
			<div className={'valentinesBannerOverlay bannerOverlay desktop600'}>
				<div className='valentinesBannerButton' onClick={() => this.internalNav('spring')}>
					Learn More
				</div>
			</div>
			<div className={'valentinesBannerOverlay bannerOverlay mobile600'}>
				<div className='valentinesBannerButton' onClick={() => this.internalNav('spring')}>
					Learn More
				</div>
			</div>
		</div>;
  }

  renderMothers2019Banner() {

  	return <div className={'homeBanner'}>
			<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/home/promo-banners/mothers2019/mday_homepage_a.jpg' />
			<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/home/promo-banners/mothers2019/mday_homepage_mobile.jpg' />
			<div className={'mothersBannerButton desktop600'} onClick={() => this.internalNav('mothersday')}>
				Go to Financing Terms*
			</div>
			<div className='motherOverlay' onClick={() => this.internalNav('mothersday')}></div>
		</div>;
  }

  renderSummer2019Banner() {

  	return <div className={'homeBanner'}>
			<video className='desktop600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/home/promo-banners/summer2019/summer_homepage2.mp4" type="video/mp4" />
			</video>
			<video className='mobile600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/home/promo-banners/summer2019/summer_mobile_banner2.mp4" type="video/mp4" />
			</video>
			<div className={'summerBannerOverlay bannerOverlay desktop600'}>
				<div className='summerBannerButton' onClick={() => this.internalNav('summer')}>
					Learn More
				</div>
			</div>
			<div className={'summerBannerOverlay bannerOverlay mobile600'}>
				<div className='summerBannerButton' onClick={() => this.internalNav('summer')}>
					Learn More
				</div>
			</div>
		</div>;
  }

  renderFall2019Banner() {

  	return <div className={'homeBanner'}>
			<video className='desktop600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/promopages/fall2019/home.mp4" type="video/mp4" />
			</video>
			<video className='mobile600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
			  <source src="https://s3.amazonaws.com/dd-website/img/promopages/fall2019/home_mobile.mp4" type="video/mp4" />
			</video>
			<div className={'fallBannerOverlay bannerOverlay desktop600'}>
				<div className='fallBannerButton' onClick={() => this.internalNav('5yearfinancing')}>
					*Go to Financing Terms
				</div>
			</div>
			<div className={'fallBannerOverlay bannerOverlay mobile600'}>
				<div className='fallBannerButton' onClick={() => this.internalNav('5yearfinancing')}>
					*Go to Financing Terms
				</div>
			</div>
		</div>;
  }

  renderNoKidHungryBanner() {
		return <div className={'homeBanner rotatingBannerItem'}>
			<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_banner_x.jpg' />
			<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_banner_x_m.jpg' />
			<div className={'mothersBannerButton noKidBannerButton'} onClick={() => this.internalNav('no-kid-hungry')}>Learn More</div>
		</div>;
  }

  renderHoliday2022Banner() {
  	return <div className={'homeBanner rotatingBannerItem'}>
  		<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2.jpg' />
			<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/home/holiday_ex2_m.jpg' />
			<div className={'promoBannerButton variant2'} onClick={this.giftsNav.bind(this)}><div>Shop Now</div></div>
		</div>;
  }

	render() {
		return <div className='Home'>

			<img src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=content&pixid=7333a400-055a-4ea4-a1b7-835149f34435" width="1" height="1" />

			<div className='homePreBanner'>
				<LazyLoadImage className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/home/prebanner/pandorapencil_bg.jpg' alt='Pandora' />
				<LazyLoadImage className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/home/prebanner/pandorapencil_bgmobile.jpg' alt='Pandora' />
				<div className='preBannerOverlay'>
					<div className={'desktopOnly preBannerContent'} onClick={() => this.newTabNav('http://pandora.com/DiamondsDirect')}>Listen to Winter Wonderland by Diamonds Direct on &nbsp;<img src='https://ddw2.diamondsdirect.com/img/home/prebanner/Pandora_2016_logo.svg' /> and jingle while you shop! &nbsp;<span className='listenLink'>Listen Now</span></div>
					<div className={'mobileOnly preBannerContent'} onClick={() => this.newTabNav('http://pandora.com/DiamondsDirect')}><span className='listenLink'>Listen</span> to our Winter Wonderland station on &nbsp;<img src='https://ddw2.diamondsdirect.com/img/home/prebanner/Pandora_2016_logo.svg' /></div>
				</div>
			</div>

			<div>{this.renderRotatingBanner()}</div>

			<div className='bestsellersWrapper'>
				<div className='bestTitle'>Gift earrings and save! This weekend only!</div>
				<div className='bestItems'>
					<div className={'bestLHS'}>
						<div className='largeItemWrapper' onClick={() => this.userNav('jewelry/EFAND20939')}>
							<div className={'largeImg holidayImgLarge'}>
								<div className='largeScreen'>
									<div className='largeScreenText'>
										<div className='largeScreenTitle'>Floating Diamond Chain Drop Earrings</div>
										<div className='largeScreenSubtitle'>Starting at $1,250</div>
									</div>
								</div>
							</div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Floating Diamond Chain Drop Earrings</div>
								<div className='itemLabelPrice'>Starting at $1,250</div>
							</div>
						</div>
					</div>
					<div className={'bestRHS'}>
						<div className='itemGridWrapper'>
							<div className='smallItemRow'>
								<div className='smallItemWrapper' onClick={() => this.userNav('jewelry/EFAND17698')}>
									<div className={'smallImg holidayImg1'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Diamond Quad Stud Earrings</div>
												<div className='smallScreenSubtitle'>Starting at $4,950</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Diamond Quad Stud Earrings</div>
										<div className='itemLabelPrice'>Starting at $4,950</div>
									</div>
								</div>
								<div className='smallItemWrapper' onClick={() => this.userNav('jewelry/EFAND19614')}>
									<div className={'smallImg holidayImg2'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Diamond Paperclip Link Earrings</div>
												<div className='smallScreenSubtitle'>Starting at $2,750</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Diamond Paperclip Link Earrings</div>
										<div className='itemLabelPrice'>Starting at $2,750</div>
									</div>
								</div>
							</div>
							<div className='smallItemRow'>
								<div className='smallItemWrapper' onClick={() => this.userNav('jewelry/EFAND17563')}>
									<div className={'smallImg holidayImg3'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Graduated Seven Stone Earrings</div>
												<div className='smallScreenSubtitle'>Starting at $2,650</div>
											</div>
										</div>
									</div>									
									<div className='itemLabel'>
										<div className='itemLabelName'>Graduated Seven Stone Earrings</div>
										<div className='itemLabelPrice'>Starting at $2,650</div>
									</div>
								</div>
								<div className='smallItemWrapper' onClick={() => this.userNav('diamond-studs')}>
									<div className={'smallImg holidayImg4'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Diamond Studs</div>
												<div className='smallScreenSubtitle'>Starting at $380</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Diamond Studs</div>
										<div className='itemLabelPrice'>Starting at $380</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={'bestMobile mobileOnly'}>
						<div className='mobileItemWrapper' onClick={() => this.userNav('jewelry/EFAND20939')}>
							<div className={'mobileImg holidayImgLarge'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Floating Diamond Chain Drop Earrings</div>
								<div className='itemLabelPrice'>Starting at $1,250</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('jewelry/EFAND17698')}>
							<div className={'mobileImg holidayImg1'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Diamond Quad Stud Earrings</div>
								<div className='itemLabelPrice'>Starting at $4,950</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('jewelry/EFAND19614')}>
							<div className={'mobileImg holidayImg2'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Diamond Paperclip Link Earrings</div>
								<div className='itemLabelPrice'>Starting at $2,750</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('jewelry/EFAND17563')}>
							<div className={'mobileImg holidayImg3'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Graduated Seven Stone Earrings</div>
								<div className='itemLabelPrice'>Starting at $2,650</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('diamond-studs')}>
							<div className={'mobileImg holidayImg4'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Diamond Studs</div>
								<div className='itemLabelPrice'>Starting at $380</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className='homeMidWrapper'>
				<div className='sectionRow'>
					<div className={'rowImage imageLeft'}>
						<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/influence/new1.png' alt='Shop Engagement' />
					</div>
					<div className={'rowContent contentRight'}>
						<div className='contentWrapper'>
							<div className='contentTitle'>Love First</div>
							<div className='contentBody'>Diamonds Direct is your source for lab-grown and natural diamonds this holiday season!</div>
							<div className='contentCTA' onClick={() => this.internalNav('education/lab-grown')}>
								<div className='ctaLabel'>Learn More</div>
								<div className={'ctaUnderline ctaEngagement'}></div>
							</div>
						</div>
					</div>
				</div>
				<div className='sectionRow'>
					<div className={'rowImage imageRight'}>
						<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/influence/new2.jpg' alt='Virtual appointments' />
					</div>
					<div className={'rowContent contentLeft'}>
						<div className='contentWrapper videoChatWrapper'>
							<div className='contentTitle'>Appointments</div>
							<div className='contentBody'>Need guidance? Our experts are here to help! Connect with an expert in-store or online.</div>
							<div className='contentCTA' onClick={() => this.internalNav('contact-us')}>
								<div className='ctaLabel'>Connect with an Expert</div>
							</div>
							<div className='contentCTA'>
								<div className={'ctaUnderline ctaAppointment'}></div>
							</div>
							<div className='contentCTA' onClick={() => this.internalNav('video-chat')}>
								<div className={'ctaLabel videoLabel'}>Video Chat Now</div>
							</div>
						</div>
					</div>
				</div>
				<div className='sectionRow'>
					<div className={'rowImage imageLeft'}>
						<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/influence/holiday_influence.jpg' alt='Shop Influencer Jewelry Box' />
					</div>
					<div className={'rowContent contentRight'}>
						<div className='contentWrapper'>
							<div className='contentTitle'>Influencer Jewelry Box</div>
							<div className='contentBody'>Need inspiration? Browse influencer jewelry boxes for top holiday gift ideas.</div>
							<div className='contentCTA' onClick={() => this.internalNav('jewelry-box')}>
								<div className='ctaLabel'>Shop Influencer Jewelry Box</div>
								<div className={'ctaUnderline ctaEngagement'}></div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className={'bestsellersWrapper verragioBestsellers topBestsellers'}>
				<div className='bestTitle'>Top Holiday Gifts</div>
				<div className='bestItems'>
					<div className={'bestLHS'}>
						<div className='largeItemWrapper' onClick={() => this.userNav('setting/SMD1817108')}>
							<div className={'largeImg novImgLarge'}>
								<div className='largeScreen'>
									<div className='largeScreenText'>
										<div className='largeScreenTitle'>Vintage-Inspired Engagement Setting</div>
										<div className='largeScreenSubtitle'>Priced at $1,650</div>
									</div>
								</div>
							</div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Vintage-Inspired Engagement Setting</div>
								<div className='itemLabelPrice'>Priced at $1,650</div>
							</div>
						</div>
					</div>
					<div className={'bestRHS'}>
						<div className='itemGridWrapper'>
							<div className='smallItemRow'>
								<div className='smallItemWrapper' onClick={() => this.userNav('jewelry/BLDMD19406')}>
									<div className={'smallImg novImg1'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Single-Prong Diamond Band</div>
												<div className='smallScreenSubtitle'>Starting at $1,430</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Single-Prong Diamond Band</div>
										<div className='itemLabelPrice'>Starting at $1,430</div>
									</div>
								</div>
								<div className='smallItemWrapper' onClick={() => this.userNav('jewelry/BLDSM20917')}>
									<div className={'smallImg novImg2'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Milgrain Diamond Band</div>
												<div className='smallScreenSubtitle'>Priced at $890</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Milgrain Diamond Band</div>
										<div className='itemLabelPrice'>Priced at $890</div>
									</div>
								</div>
							</div>
							<div className='smallItemRow'>
								<div className='smallItemWrapper' onClick={() => this.userNav('setting/SMD1463388')}>
									<div className={'smallImg novImg3'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Marquise Halo Setting</div>
												<div className='smallScreenSubtitle'>Priced at $2,060</div>
											</div>
										</div>
									</div>									
									<div className='itemLabel'>
										<div className='itemLabelName'>Marquise Halo Setting</div>
										<div className='itemLabelPrice'>Priced at $2,060</div>
									</div>
								</div>
								<div className='smallItemWrapper' onClick={() => this.userNav('jewelry/BDSAP03625')}>
									<div className={'smallImg novImg4'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Sapphire &amp; Diamond Band</div>
												<div className='smallScreenSubtitle'>Starting at $1,150</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Sapphire &amp; Diamond Band</div>
										<div className='itemLabelPrice'>Starting at $1,150</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={'bestMobile mobileOnly'}>
						<div className='mobileItemWrapper' onClick={() => this.userNav('setting/SMD1817108')}>
							<div className={'mobileImg novImgLarge'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Vintage-Inspired Engagement Setting</div>
								<div className='itemLabelPrice'>Priced at $1,650</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('jewelry/BLDMD19406')}>
							<div className={'mobileImg novImg1'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Single-Prong Diamond Band</div>
								<div className='itemLabelPrice'>Starting at $1,430</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('jewelry/BLDSM20917')}>
							<div className={'mobileImg novImg2'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Milgrain Diamond Band</div>
								<div className='itemLabelPrice'>Priced at $890</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('setting/SMD1463388')}>
							<div className={'mobileImg novImg3'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Marquise Halo Setting</div>
								<div className='itemLabelPrice'>Priced at $2,060</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('jewelry/BDSAP03625')}>
							<div className={'mobileImg novImg4'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Sapphire &amp; Diamond Band</div>
								<div className='itemLabelPrice'>Starting at $1,150</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='homeMidWrapper'>

				<div className='sectionRow'>
					<div className={'rowImage imageRight'}>
						<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/influence/new3.jpg' alt='Shop Fine Jewelry' />
					</div>
					<div className={'rowContent contentLeft'}>
						<div className='contentWrapper'>
							<div className='contentTitle'>Celebrate Everything</div>
							<div className='contentBody'>At Diamonds Direct, your love is our passion and we’re dedicated to helping you find the perfect ring.</div>
							<div className='contentCTA' onClick={() => this.internalNav('gallery/fine-jewelry?type=ring,earring,bracelet,necklace')}>
								<div className='ctaLabel'>Shop Engagement</div>
								<div className={'ctaUnderline ctaFashion'}></div>
							</div>
						</div>
					</div>
				</div>
			</div>



			<div className={'bestsellersWrapper verragioBestsellers'} style={{display: 'none'}}>
				<div className='bestTitle'>
					Now Trending: Vintage-Inspired Engagement Rings
				</div>
				<div className='bestItems'>
					<div className={'bestLHS'}>
						<div className='largeItemWrapper' onClick={() => this.userNav('classique-engagement-ring-Z1836.html?qvw=1')}>
							<div className={'largeImg novImgLarge'}>
								<div className='largeScreen'>
									<div className='largeScreenText'>
										<div className='largeScreenTitle'>Classique Scalloped Milgrain Ring</div>
										<div className='largeScreenSubtitle'>Priced at $970</div>
									</div>
								</div>
							</div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Classique Scalloped Milgrain Ring</div>
								<div className='itemLabelPrice'>Priced at $970</div>
							</div>
						</div>
					</div>
					<div className={'bestRHS'}>
						<div className='itemGridWrapper'>
							<div className='smallItemRow'>
								<div className='smallItemWrapper' onClick={() => this.userNav('simon-g-engagement-ring-TR529.html?qvw=1')}>
									<div className={'smallImg novImg1'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Simon G. Pavé Swirl Ring</div>
												<div className='smallScreenSubtitle'>Starting at $1,826</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Simon G. Pavé Swirl Ring</div>
										<div className='itemLabelPrice'>Starting at $1,826</div>
									</div>
								</div>
								<div className='smallItemWrapper' onClick={() => this.userNav('classique-engagement-ring-Z1737MM10X5.0Y4.html')}>
									<div className={'smallImg novImg2'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Classique Milgrain Halo Ring</div>
												<div className='smallScreenSubtitle'>Priced at $1,610</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Classique Milgrain Halo Ring</div>
										<div className='itemLabelPrice'>Priced at $1,610</div>
									</div>
								</div>
							</div>
							<div className='smallItemRow'>
								<div className='smallItemWrapper' onClick={() => this.userNav('classique-engagement-ring-Z1721EE8.0X6.0Y4.html')}>
									<div className={'smallImg novImg3'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Classique Cluster Halo Ring</div>
												<div className='smallScreenSubtitle'>Priced at $1,390</div>
											</div>
										</div>
									</div>									
									<div className='itemLabel'>
										<div className='itemLabelName'>Classique Cluster Halo Ring</div>
										<div className='itemLabelPrice'>Priced at $1,390</div>
									</div>
								</div>
								<div className='smallItemWrapper' onClick={() => this.userNav('sylvie-engagement-ring-S1132.html')}>
									<div className={'smallImg novImg4'}>
										<div className='smallScreen'>
											<div className='smallScreenText'>
												<div className='smallScreenTitle'>Sylvie Vintage Bezel Ring</div>
												<div className='smallScreenSubtitle'>Starting at $2,750</div>
											</div>
										</div>
									</div>
									<div className='itemLabel'>
										<div className='itemLabelName'>Sylvie Vintage Bezel Ring</div>
										<div className='itemLabelPrice'>Starting at $2,750</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={'bestMobile mobileOnly'}>
						<div className='mobileItemWrapper' onClick={() => this.userNav('classique-engagement-ring-Z1836.html?qvw=1')}>
							<div className={'mobileImg novImgLarge'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Classique Scalloped Milgrain Ring</div>
								<div className='itemLabelPrice'>Priced at $970</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('simon-g-engagement-ring-TR529.html?qvw=1')}>
							<div className={'mobileImg novImg1'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Simon G. Pavé Swirl Ring</div>
								<div className='itemLabelPrice'>Starting at $1,826</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('classique-engagement-ring-Z1737MM10X5.0Y4.html')}>
							<div className={'mobileImg novImg2'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Classique Milgrain Halo Ring</div>
								<div className='itemLabelPrice'>Priced at $1,610</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('classique-engagement-ring-Z1721EE8.0X6.0Y4.html')}>
							<div className={'mobileImg novImg3'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Classique Cluster Halo Ring</div>
								<div className='itemLabelPrice'>Priced at $1,390</div>
							</div>
						</div>
						<div className='mobileItemWrapper' onClick={() => this.userNav('sylvie-engagement-ring-S1132.html')}>
							<div className={'mobileImg novImg4'}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>Sylvie Vintage Bezel Ring</div>
								<div className='itemLabelPrice'>Starting at $2,750</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='storyWrapper' style={{ display: 'none' }}>
				<div className={this.getDiscoverVideoClass()}>
					<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/home/video_thumb.jpg' onClick={::this.startVideo} alt='Click to start video' />
					<div className={'videoSprite'} onClick={::this.startVideo}></div>
					<video controls controlsList="nodownload" id="discovervideo" ref={(vid) => { this.discover = vid; }}>
					  <source src="https://s3.amazonaws.com/dd-website/img/home/aboutuslbr.mp4" type="video/mp4" />
					  <LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/home/video_thumb.jpg' alt='Click to start video' />
					</video>
				</div>
				<div className='videoDescription'>
					<div className='videoDescriptoinWrapper'>
						<div className='videoDescriptoinTitle'>Our Story</div>
						<div className='videoDescriptoinBody'>No mere accessory, your jewelry is a statement to the world. With our unparalleled selection you are sure to find the perfect piece for you.</div>
						<div className='videoDescriptoinCTA' onClick={() => this.userNav('about-us')}>
							<div className='videoCtaLabel'>Discover More</div>
							<div className={'videoCtaUnderline videoCtaDiscover'}></div>
						</div>
					</div>
				</div>
			</div>
			<div className='bottomLinks' style={{ display: 'none' }}>
				<div className='linkWrapper' onClick={() => this.internalNav('heroes')}>
					<div className='linkImgWrapper'>
						<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/home/military.jpg' alt='Military Discount' />
					</div>
					<div className='linkLabelWrapper'>
						<div className='linkLabelTitle'>Military Discount</div>
						<div className='linkLabelBody'>Special discount for military, police, fire, and paramedics.</div>
					</div>
				</div>
				<div className='linkWrapper' onClick={() => this.userNav('appointments')}>
					<div className='linkImgWrapper'>
						<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/home/appt_03.jpg' alt='Chat with an Expert' />
					</div>
					<div className='linkLabelWrapper'>
						<div className='linkLabelTitle'>Chat with an Expert</div>
						<div className='linkLabelBody'>Make an appointment with a diamond expert for personalized care and assistance.</div>
					</div>
				</div>
				<div className='linkWrapper' onClick={() => this.userNav('our-foundation')}>
					<div className='linkImgWrapper'>
						<LazyLoadImage src='https://s3.amazonaws.com/dd-website/img/home/community.jpg' alt='Community Giving' />
					</div>
					<div className='linkLabelWrapper'>
						<div className='linkLabelTitle'>Community Giving</div>
						<div className='linkLabelBody'>Giving back is at the heart of everything we do. Learn more about The Diamonds Direct Foundation.</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default Home;

function mapStateToProps(state) {
  return {
    header: state.header,
  };
}

export const HomeContainer = connect(
  mapStateToProps,
  allActionCreators
)(Home);


// WEBPACK FOOTER //
// ./src/components/views/home/Home.jsx